export default __webpack_public_path__ + "static/media/nucleo.5c65ef4d.woff";